import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20warm%20atmospheric%20Chinese%20aesthetic%20background%20with%20soft%20golden%20light%20rays%20diffusing%20through%20silk%20fabric%20texture%2C%20gentle%20flowing%20curves%20suggesting%20comfort%20and%20warmth%2C%20abstract%20ink%20wash%20patterns%20in%20warm%20earth%20tones%2C%20cream%20and%20amber%20color%20palette%2C%20ethereal%20and%20dreamy%20atmosphere%2C%20soft%20focus%20artistic%20composition%2C%20serene%20emotional%20mood&width=1920&height=800&seq=cta-bg-2026&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-background-900/50"></div>
      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading text-background-50 mb-4">
          准备好探索掌中的美母了吗？
        </h2>
        <p className="text-background-100/80 mb-8 text-sm md:text-base leading-relaxed">
          每一个细节都值得品味，每一份感受都值得珍藏。现在就开始您的探索之旅吧。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/core-value"
            className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-50 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors duration-300 whitespace-nowrap"
          >
            开始探索
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-colors duration-300 whitespace-nowrap"
          >
            关于我们
          </Link>
        </div>
      </div>
    </section>
  );
}